import React from 'react'

import { useTranslation } from 'react-i18next'

import { FilterFieldSelectorProps } from './types'
import { useFilterConditionContext } from './useFilterCondition'
import { FieldLabel } from '@/Atomic/Atoms/FieldLabel'
import { BasicSelect } from '@/Atomic/Atoms/Inputs/BasicSelect'

/**
 * FilterFieldSelector - Handles field/attribute selection
 * Displays a dropdown to select which field to filter on
 */
export const FilterFieldSelector: React.FC<FilterFieldSelectorProps> = () => {
  const { t } = useTranslation()
  const {
    condition,
    conditionEntity,
    isFirstRow,
    fieldOptions,
    hasFieldError,
    isLoadingSchema,
    handleFieldChange,
    handleClearFieldError,
  } = useFilterConditionContext()

  return (
    <div className="form-field field-selector">
      {isFirstRow && (
        <FieldLabel
          name={`field-${condition.id}`}
          label={t('filter.attribute')}
        />
      )}
      <BasicSelect
        key={`field-${condition.id}-${conditionEntity}`}
        name={`field-${condition.id}`}
        placeholder={t('filter.attribute')}
        hasError={hasFieldError}
        options={fieldOptions}
        value={fieldOptions.find((opt) => opt.value === condition.field)}
        onChange={(option) =>
          handleFieldChange((option as { value: string } | null)?.value ?? '')
        }
        onFocus={handleClearFieldError}
        isClearable={false}
        isLoading={isLoadingSchema}
        isDisabled={isLoadingSchema}
      />
    </div>
  )
}
